import styled, { css } from 'styled-components';
import mq from '../../../utils/mediaQueries.js';
import { Button } from '../../Button/Button.style.js';
import { isDefaultTheme } from '../../../utils/theming.js';

// @ts-nocheck
var CardPaymentInfo = styled.div.withConfig({
  displayName: "CardPaymentInfostyle__CardPaymentInfo",
  componentId: "sc-basi8z-0"
})(["", " ", " ", "{align-self:flex-end;", "}"], function (_ref) {
  var $variant = _ref.$variant;
  return $variant !== 'article' && css(["padding-top:var(--space-400);border-top:solid 1px var(--color-border-key-line);"]);
}, isDefaultTheme(css(["", ""], function (_ref2) {
  var $isPortraitCard = _ref2.$isPortraitCard,
    $footerAtBottom = _ref2.$footerAtBottom;
  return !$isPortraitCard && !$footerAtBottom && css(["", ""], mq.m(css(["width:329px;flex-shrink:0;border-top:unset;border-left:solid 1px var(--color-border-key-line);padding:0 0 0 var(--space-500);margin-left:var(--space-500);"])));
})), Button, isDefaultTheme(css(["width:100%;", ""], function (_ref3) {
  var $footerAtBottom = _ref3.$footerAtBottom,
    $isPortraitCard = _ref3.$isPortraitCard,
    $columnSpan = _ref3.$columnSpan,
    $noDescription = _ref3.$noDescription;
  var isSmallPortrait = $isPortraitCard && $columnSpan < 6;
  if ($noDescription) {
    return css(["width:auto;", ""], mq.m(css(["width:", ";"], !$footerAtBottom && !$isPortraitCard ? '100%' : 'auto')));
  }
  if ($footerAtBottom && !isSmallPortrait) {
    return css(["", ""], mq.m(css(["width:auto;"])));
  }
  return '';
})));
var InnerWrapper = styled.div.withConfig({
  displayName: "CardPaymentInfostyle__InnerWrapper",
  componentId: "sc-basi8z-1"
})(["display:flex;flex-direction:column;justify-content:flex-end;height:100%;"]);
var totalPriceContainer = styled.div.withConfig({
  displayName: "CardPaymentInfostyle__totalPriceContainer",
  componentId: "sc-basi8z-2"
})(["display:flex;justify-content:space-between;align-items:center;margin-bottom:var(--space-400);"]);
var rowContainer = styled.div.withConfig({
  displayName: "CardPaymentInfostyle__rowContainer",
  componentId: "sc-basi8z-3"
})(["display:flex;justify-content:space-between;align-items:center;margin:var(--space-400) 0;"]);
var reservedPaymentsContainer = styled.div.withConfig({
  displayName: "CardPaymentInfostyle__reservedPaymentsContainer",
  componentId: "sc-basi8z-4"
})(["display:flex;flex-direction:column;align-items:center;margin-bottom:var(--space-500);"]);
var reservedPayments = styled.span.withConfig({
  displayName: "CardPaymentInfostyle__reservedPayments",
  componentId: "sc-basi8z-5"
})(["display:flex;justify-content:space-between;width:100%;"]);
var futurePayments = styled.div.withConfig({
  displayName: "CardPaymentInfostyle__futurePayments",
  componentId: "sc-basi8z-6"
})(["display:grid;grid-template-columns:1fr 2fr auto;column-gap:var(--space-200);margin-top:var(--space-100);"]);
styled.div.withConfig({
  displayName: "CardPaymentInfostyle__InfoScarcity",
  componentId: "sc-basi8z-7"
})(["display:flex;justify-content:center;align-items:center;font:var(--font-body-s);font-weight:700;line-height:2rem;border-radius:var(--border-radius-200);background-color:var(--color-teal-500);color:var(--color-text);padding:var(--space-200);width:100%;"]);

export { CardPaymentInfo, InnerWrapper, futurePayments, reservedPayments, reservedPaymentsContainer, rowContainer, totalPriceContainer };
//# sourceMappingURL=CardPaymentInfo.style.js.map
